import React from 'react';

import LoadingSpinner from '../../../../components/LoadingSpinner';

const MessageLoading: React.FC = () => {
  return (
    <div className='flex-1 flex items-center justify-center'>
      <div className='text-center'>
        <div className='text-sm text-gray-600 mb-2'>
          Loading messages...
        </div>
        <LoadingSpinner size='md' className='mx-auto' />
      </div>
    </div>
  );
};

export default MessageLoading;